import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CrudService } from '../../../crud/crud.service';
import { NotificationsService } from 'angular2-notifications';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from "moment";
import { isObject } from 'util';

@Component({
  selector: "app-pagos-formulario",
  templateUrl: "./formulario.component.html"
})
export class PagosFormularioComponent implements OnInit{
  tipo = [];
  facturacion_inicio = false;
  dato: FormGroup;
  form_pagos: any;
  form_movimientos_articulos: any;
  cargando = false;
  movimientos_articulos;
  codigo_barras_activo = false;
  caja_abierta = false;
  stocks = [];
  auto = 0;
  ticket;
  borrarCargando;
  error_venta = false;
  venta_ok = false;
  json;
  reimprimir = false;
  sin_resultado = "";
  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");
  idGuardado = null;
  tieneid: boolean = false;
  time_cambio_cantidad_stoc;
  time_cambio_cantidad_articulo_key;
  time_pago;
  tamano = document.body.clientHeight;

  public startValue: string;
  public selected: string;
  public options = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  };

  url_nuevo = "../../nuevo";
  lista_colas = false;
  subtotal = 0;
  descuento = 0;
  iva = 0;
  total = 0;
  total_recibido = 0;
  cambio = 0;

  usuario;
  caja;
  busqueda;
  objeto = {
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 3000
  };
  alumnos = {
    id: '',
    alumnos_metadatos: {
      nombre: ""
    },
    becas: {
      importe: 0
    },
    personas_rfcs: [],
    factura_rfc: {
      razon_social: "",
      rfc: "",
      codigo_postal: ""
    }
  };

  documentos_no = false;
  configuracion;
  inscripciones = [];

  dias_pago_normal_colegiatura = 0;
  dias_pago_normal_reinscripcion = 0;
  porcentaje_recargo_colegiatura = 0;
  porcentaje_recargo_reinscripcion = 0;
  importe_recargo_colegiatura = 0;
  importe_recargo_reinscripcion = 0;
  cupones = [];
  cupones_disponibles;
  importe_cupon = 0;
  constructor(
    private fb: FormBuilder,
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private notificacion: NotificationsService
  ) {}

  ngOnInit(): void {
    // obtener los datos del usiario logueado almacen y clues
    this.configuracion = JSON.parse(localStorage.getItem("configuracion"));
    this.usuario = JSON.parse(localStorage.getItem("usuario"));
    this.caja = localStorage.getItem("caja");

    if (this.caja != "") {
      this.caja_abierta = true;
    }
    // inicializar el formulario reactivo
    this.iniciar_formulario();

    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
        this.idGuardado = params["id"];
      }
    });

    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();

    ////////// facturacion
    this.iniciar_form_factura("D10");
  }
  iniciar_formulario() {
    this.dato = this.fb.group({
      id: [""],
      bancos_id: [""],
      cuentas_bancarias_id: [""],
      fecha: [""],
      hora: [""],
      sucursal: [""],
      uso_cfdi: ["D10"],
      cantidad: [0],
      facturas_id: [''],
      observaciones: [""],
      tipos_formas_pagos_id: "01",
      tipos_metodos_pagos_id: "PUE",
      personas_id: [""],
      tipos_movimientos_id: 2,
      personas: this.fb.group({
        nombre: [""],
        apellido_materno: [""],
        apellido_paterno: [""]
      })
    });
  }
  reset_form() {
    this.selected = "";
    this.startValue = "";
    this.dato.reset();
    for (let item in this.dato.controls) {
      const ctrl = <FormArray>this.dato.controls[item];
      if (ctrl.controls) {
        if (typeof ctrl.controls.length == "number") {
          while (ctrl.length) {
            ctrl.removeAt(ctrl.length - 1);
          }
          ctrl.reset();
        }
      }
    }
    this.dato.controls.tipos_movimientos_id.patchValue(2);
  }

  enviar() {
    this.cargando = true;
    this.json = this.dato.getRawValue();
    this.json.alumnos = this.alumnos;
    document
      .getElementById("confirmarLiquidacion")
      .classList.remove("is-active");
    if (this.dato.get("id").value > 0) {
      this.crudService
        .editar(this.dato.get("id").value, this.json, "pago-publico")
        .subscribe(
          resultado => {
            this.enviar_ticket(this.json, resultado);

            this.venta_ok = true;

            setTimeout(() => {
              this.venta_ok = false;
            }, 1500);
          },
          error => {
            this.cargando = false;
            this.error_venta = true;
          }
        );
    } else {
      this.crudService.crear(this.json, "pago-publico").subscribe(
        resultado => {
          this.enviar_ticket(this.json, resultado);
          this.venta_ok = true;

          setTimeout(() => {
            this.venta_ok = false;
          }, 1500);
          this.reset_form();
        },
        error => {
          this.cargando = false;
          this.error_venta = true;
          setTimeout(() => {
            this.error_venta = false;
          }, 2500);
        }
      );
    }
  }

  enviar_ticket(json, resultado = null) {
    this.cargando = false;

    setTimeout(() => {
      this.venta_ok = false;
    }, 3000);
    this.json = resultado ? resultado.data : json;

    this.error_venta = false;
    if (resultado) {
      if (resultado.status == 200) {
        this.idGuardado = resultado.id;
        document.getElementById("guardado_exito").classList.add("is-active");
        this.iniciar_form_factura(this.dato.get("uso_cfdi").value);
        this.ventas_facturar = [];
        this.cargar_factura(false, resultado);
      } else {
        this.sin_resultado = resultado.messages;
        setTimeout(() => {
          this.sin_resultado = "";
        }, 3500);
      }

      this.iniciar_formulario();

      this.cargando = false;
    }
  }

  /////////////////////////////////// facturacion ///////////////////////////////////
  facturacion;

  error_timbre = false;
  valido = false;
  error_busqueda = false;
  errores = [];
  todas_ventas = false;
  activarRfc = false;
  activarUso = false;
  seleccionar_iva = false;

  codigo = "";
  cliente = "";
  facturas_mes = [];
  requiere_factura = 1;

  ventas_facturar = [];
  ventas_mes_facturar = [];
  desglosar_impuestos = true;
  con_impuesto = true;
  VERSION_CFDI = environment.VERSION_CFDI;
  CFDI_PATH = environment.CFDI_PATH;

  date = new Date();

  abrir_facturacion() {
    document.getElementById("verPdf").classList.add("is-active");
  }

  cargarEditarFactura(facturacion){
    let resultado = {
      data: {
        uso_cfdi:this.dato.get('uso_cfdi').value
      },
      facturacion: facturacion,
      status: 200
    };
    this.cargar_factura(false, resultado);
  };

  iniciar_form_factura(uso_cfdi) {
    this.facturacion = {
      Version: this.VERSION_CFDI,
      Serie: this.configuracion.sucursal.facturacion.serie,
      Folio: "",
      Fecha: moment
        .utc(
          moment(
            new Date(
              this.date.getTime() - this.date.getTimezoneOffset() * 60000
            )
          )
        )
        .format(),
      Sello: "",
      NoCertificado: "",
      Certificado: "",
      SubTotal: 0,
      Moneda: this.configuracion.sucursal.moneda,
      Total: 0,
      TotalLetra: "",
      TipoDeComprobante: "I",
      FormaPago: "",
      MetodoPago: "",
      CondicionesDePago: "Contado",
      Descuento: 0,
      LugarExpedicion: this.configuracion.sucursal.facturacion.lugar_expedicion,
      CfdiRelacionados: { TipoRelacion: "", CfdiRelacionado: [{ UUID: "" }] },
      Emisor: {
        Rfc: this.configuracion.sucursal.facturacion.rfc,
        Nombre: this.configuracion.sucursal.facturacion.razon_social,
        RegimenFiscal: this.configuracion.sucursal.facturacion.regimen_fiscal
      },
      Receptor: { Rfc: "", Nombre: "", UsoCFDI: uso_cfdi },
      Conceptos: { Concepto: [] },
      Impuestos: {
        TotalImpuestosTrasladados: 0,
        TotalImpuestosRetenidos: 0,
        Traslados: [],
        Retenciones: []
      },
      Complemento: {
        TimbreFiscalDigital: {
          FechaTimbrado: "",
          UUID: "",
          NoCertificadoSAT: "",
          SelloCFD: "",
          SelloSAT: "",
          CadenaOriginal: "",
          qr: ""
        }
      }
    };

    this.facturacion_inicio = true;
  }

  cargar_factura(es_publico, resultado) {

    if (resultado.status === 200) {
      this.facturacion.uso_cfdi = resultado.data.uso_cfdi;
      this.facturacion.Receptor.Rfc =
        resultado.facturacion.personas.personas_rfcs[0].rfc;
      this.facturacion.Receptor.Nombre =
        resultado.facturacion.personas.personas_rfcs[0].razon_social;
      this.valido = true;

      this.ventas_facturar.push(resultado.facturacion.id);

      let forma_pago = resultado.facturacion.pagos[0].tipos_formas_pagos_id;

      // datos generales
      this.facturacion.Serie = this.configuracion.sucursal.facturacion.serie;
      this.facturacion.Folio = resultado.facturacion.folio;
      this.facturacion.Fecha = moment
        .utc(
          moment(
            moment
              .utc(
                moment(
                  new Date(
                    this.date.getTime() - this.date.getTimezoneOffset() * 60000
                  )
                )
              )
              .format()
          )
        )
        .format();
      this.facturacion.FormaPago =
        resultado.facturacion.pagos[0].tipos_formas_pagos_id;
      this.facturacion.MetodoPago =
        resultado.facturacion.pagos[0].tipos_metodos_pagos_id;

      let suma_impuesto_rete = [];
      let suma_impuesto_tras = [];
      let suma_descuento = 0;
      let subtotal = 0;
      let total_descuento = 0;
      let total = 0;
      // conceptos
      let grupos_impuestos = { Traslado: [], Retencion: [] };
      let todos_impuestos_t = [];
      let todos_impuestos_r = [];
      resultado.facturacion.movimientos_articulos.forEach(elem => {
        let impuestos = elem.articulos.articulos_impuestos
          ? elem.articulos.articulos_impuestos.impuestos
          : { traslados: [], retenciones: [] };
        // importe del articulo
        let precio_unitario = 0;
        let importe = parseFloat(elem.importe);
        let impuesto_incluido = { Traslados: [], Retenciones: [] };
        // ver si se desglosa el impuesto, en caso contrario se agrega
        let descuento = 0;
        if (this.desglosar_impuestos) {
          let desglosar = 0;
          let imp_des = 0;
          impuestos.traslados.forEach(el => {
            let impp = importe - importe / (1 + parseFloat(el.cuota));
            desglosar += parseFloat(impp.toFixed(2));
            imp_des += parseFloat(el.cuota);
          });

          impuestos.retenciones.forEach(el => {
            let impp = importe - importe / (1 + parseFloat(el.cuota));
            desglosar += parseFloat(impp.toFixed(2));
            imp_des += parseFloat(el.cuota);
          });

          descuento = parseFloat(elem.descuento) / (1 + imp_des);

          importe = parseFloat((importe - desglosar).toFixed(2));

          precio_unitario = parseFloat((importe / elem.cantidad).toFixed(2));
          suma_descuento += parseFloat(descuento.toFixed(2));
        } else {
          let sumar = 0;
          descuento = parseFloat(elem.descuento);
          importe = parseFloat((importe + sumar).toFixed(2));
          precio_unitario = parseFloat((importe / elem.cantidad).toFixed(2));

          suma_descuento += descuento;
          impuestos.traslados.forEach(el => {
            let summ = importe - importe / (1 + parseFloat(el.cuota));
            sumar += parseFloat(summ.toFixed(2));
          });

          impuestos.retenciones.forEach(el => {
            let summ = importe - importe / (1 + parseFloat(el.cuota));
            sumar += parseFloat(summ.toFixed(2));
          });
        }

        impuestos.traslados.forEach(el => {
          if (!suma_impuesto_tras[el.clave]) {
            suma_impuesto_tras[el.clave] = 0;
          }
          let importe_impuesto = parseFloat((importe - descuento).toFixed(2));
          let impp = parseFloat(
            (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
          );
          suma_impuesto_tras[el.clave] += parseFloat(impp.toFixed(2));
          impuesto_incluido.Traslados.push({
            Traslado: {
              Base: importe_impuesto,
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: impp.toFixed(2)
            }
          });

          if (todos_impuestos_t.indexOf(el.clave) < 0) {
            todos_impuestos_t.push(el.clave);
            grupos_impuestos.Traslado.push(el);
          }
        });

        impuestos.retenciones.forEach(el => {
          if (!suma_impuesto_rete[el.clave]) {
            suma_impuesto_rete[el.clave] = 0;
          }
          let importe_impuesto = parseFloat((importe - descuento).toFixed(2));
          let impp = parseFloat(
            (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
          );
          suma_impuesto_rete[el.clave] += parseFloat(impp.toFixed(2));
          impuesto_incluido.Retenciones.push({
            Retencion: {
              Base: importe_impuesto,
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: impp.toFixed(2)
            }
          });

          if (todos_impuestos_r.indexOf(el.clave) < 0) {
            todos_impuestos_r.push(el.clave);
            grupos_impuestos.Retencion.push(el);
          }

        });

        total_descuento += descuento;
        subtotal += importe;
        // conceptos con complemento educativo
        this.facturacion.Conceptos.Concepto.push({
          ClaveProdServ: elem.articulos.clave_prod_serv,
          ClaveUnidad: elem.articulos.unidades_medidas.clave,
          NoIdentificacion: elem.articulos.sku,
          Cantidad: elem.cantidad,
          Unidad: elem.articulos.unidades_medidas.nombre,
          Descripcion: elem.articulos.nombre.trim(),
          ValorUnitario: precio_unitario.toFixed(2),
          PrecioReal: parseFloat(elem.precio_unitario),
          Descuento: descuento.toFixed(2),
          DescuentoReal: elem.descuento,
          Importe: importe.toFixed(2),
          Impuestos: impuesto_incluido,

          iva: true
        });
      });
      let total_impuesto_tras = 0;
      let total_impuesto_rete = 0;

      grupos_impuestos.Traslado.forEach(el => {
        total_impuesto_tras += parseFloat(suma_impuesto_tras[el.clave].toFixed(2));
        this.facturacion.Impuestos.Traslados.push({
          Traslado: {
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: suma_impuesto_tras[el.clave].toFixed(2)
          }
        });
      });
      grupos_impuestos.Retencion.forEach(el => {
        total_impuesto_rete += parseFloat(suma_impuesto_rete[el.clave].toFixed(2));
        this.facturacion.Impuestos.Retenciones.push({
          Retencion: {
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: suma_impuesto_rete[el.clave].toFixed(2)
          }
        });
      });

      this.facturacion.Impuestos.TotalImpuestosTrasladados = total_impuesto_tras.toFixed(2);
      this.facturacion.Impuestos.TotalImpuestosRetenidos = total_impuesto_rete.toFixed(2);

      let T_Total = subtotal - total_descuento + (total_impuesto_tras + total_impuesto_rete);

      this.facturacion.SubTotal = subtotal.toFixed(2);
      this.facturacion.Descuento = total_descuento.toFixed(2);
      this.facturacion.Total = T_Total.toFixed(2);

      this.recalcular_impuesto();
      document.getElementById("verPdf").classList.add("is-active");
    }
  }

  recalcular_impuesto() {
    this.facturacion.Impuestos = {
      Traslados: [],
      Retenciones: []
    };

    let posicion = 0;
    let total_total_impuesto_tras = 0;
    let total_total_impuesto_rete = 0;
    let total_subtotal = 0;
    let suma_impuesto_rete = [];
    let suma_impuesto_tras = [];
    let suma_descuento = 0;
    let subtotal = 0;
    let total_descuento = 0;
    let total = 0;
    // conceptos
    if (this.facturacion.Conceptos.Concepto) {
      let grupos_impuestos = { Traslado: [], Retencion: [] };
      let todos_impuestos_t = [];
      let todos_impuestos_r = [];
      this.facturacion.Conceptos.Concepto.forEach(elem => {
        let impuestos = elem.Impuestos;
        // importe del articulo
        let importe = elem.PrecioReal * elem.Cantidad;
        elem.ValorUnitario = elem.PrecioReal;
        let impuesto_incluido = {
          Traslados: [],
          Retenciones: []
        };

        // ver si se desglosa el impuesto, en caso contrario se agrega

        let precio_unitario = 0;
        let descuento = 0;
        if (elem.iva) {
          if (this.desglosar_impuestos) {
            let desglosar = 0;
            let imp_des = 0;
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              let impp = importe - importe / (1 + el.TasaOCuota);
              desglosar += parseFloat(impp.toFixed(2));

              imp_des += el.TasaOCuota;

              if (todos_impuestos_t.indexOf(el.Impuesto) < 0) {
                todos_impuestos_t.push(el.Impuesto);
                grupos_impuestos.Traslado.push(el);
              }
            });

            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              let impp = importe - importe / (1 + el.TasaOCuota);
              desglosar += parseFloat(impp.toFixed(2));

              imp_des += el.TasaOCuota;

              if (todos_impuestos_r.indexOf(el.Impuesto) < 0) {
                todos_impuestos_r.push(el.Impuesto);
                grupos_impuestos.Retencion.push(el);
              }
            });
            descuento = parseFloat(elem.DescuentoReal) / (1 + imp_des);

            importe = parseFloat((importe - desglosar).toFixed(2));

            precio_unitario = parseFloat(
              (importe / elem.Cantidad).toFixed(2)
            );
            suma_descuento += parseFloat(descuento.toFixed(2));
          } else {
            let sumar = 0;
            descuento = parseFloat(elem.DescuentoReal);
            importe = parseFloat((importe + sumar).toFixed(2));
            precio_unitario = parseFloat(
              (importe / elem.Cantidad).toFixed(2)
            );

            suma_descuento += descuento;
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              let summ = importe - importe / (1 + el.TasaOCuota);
              sumar += parseFloat(summ.toFixed(2));
            });

            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              let summ = importe - importe / (1 + el.TasaOCuota);
              sumar += parseFloat(summ.toFixed(2));
            });
          }

          total_descuento += descuento;
          subtotal += importe;

          if (this.con_impuesto) {
            impuesto_incluido.Traslados = [];
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              if (!suma_impuesto_tras[el.nombre]) {
                suma_impuesto_tras[el.nombre] = 0;
              }
              suma_impuesto_tras[el.nombre] += (importe - descuento) * el.TasaOCuota;
              impuesto_incluido.Traslados.push({
                Traslado: {
                  Base: (importe - descuento).toFixed(2),
                  Impuesto: el.Impuesto,
                  TipoFactor: el.TipoFactor,
                  TasaOCuota: el.TasaOCuota,
                  Importe: (
                    (importe - descuento) *
                    el.TasaOCuota
                  ).toFixed(2)
                }
              });
            });

            impuesto_incluido.Retenciones = [];
            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              if (!suma_impuesto_rete[el.nombre]) {
                suma_impuesto_rete[el.nombre] = 0;
              }
              suma_impuesto_rete[el.nombre] += (importe - descuento) * el.TasaOCuota;
              impuesto_incluido.Retenciones.push({
                Retencion: {
                  Base: (importe - descuento).toFixed(2),
                  Impuesto: el.Impuesto,
                  TipoFactor: el.TipoFactor,
                  TasaOCuota: el.TasaOCuota,
                  Importe: (
                    (importe - descuento) *
                    el.TasaOCuota
                  ).toFixed(2)
                }
              });
            });
          }
        } else {
          descuento = parseFloat(elem.DescuentoReal);
          importe = parseFloat(elem.ValorUnitario) * elem.Cantidad;
          precio_unitario = parseFloat(elem.ValorUnitario);

          total_descuento += descuento;
          subtotal += importe;
        }
        let ComplementoConcepto = this.facturacion.Conceptos.Concepto[posicion]
          .ComplementoConcepto;
        let iva = this.facturacion.Conceptos.Concepto[posicion].iva;
        this.facturacion.Conceptos.Concepto[posicion] = {
          ClaveProdServ: elem.ClaveProdServ,
          ClaveUnidad: elem.ClaveUnidad,
          NoIdentificacion: elem.NoIdentificacion,
          Cantidad: elem.Cantidad,
          Unidad: elem.Unidad,
          Descripcion: elem.Descripcion,
          ValorUnitario: precio_unitario.toFixed(2),
          PrecioReal: elem.PrecioReal,
          Descuento: descuento.toFixed(2),
          DescuentoReal: elem.DescuentoReal,
          Importe: (elem.Cantidad * precio_unitario).toFixed(2),
          ComplementoConcepto: ComplementoConcepto,
          iva: iva
        };

        total_subtotal += elem.Cantidad * precio_unitario;

        if (this.con_impuesto) {
          this.facturacion.Conceptos.Concepto[posicion].Impuestos = impuesto_incluido;
        }

        posicion++;
      });

      if (this.con_impuesto) {
        grupos_impuestos.Traslado.forEach(el => {
          if (suma_impuesto_tras[el.clave]) {
            total_total_impuesto_tras += suma_impuesto_tras[el.clave];
            this.facturacion.Impuestos.Traslados.push({
              Traslado: {
                Impuesto: el.clave,
                TipoFactor: el.factor,
                TasaOCuota: el.cuota,
                Importe: suma_impuesto_tras[el.clave].toFixed(2)
              }
            });
          }
        });
        grupos_impuestos.Retencion.forEach(el => {
          if (suma_impuesto_rete[el.clave]) {
            total_total_impuesto_rete += suma_impuesto_rete[el.clave];
            this.facturacion.Impuestos.Retenciones.push({
              Retencion: {
                Impuesto: el.clave,
                TipoFactor: el.factor,
                TasaOCuota: el.cuota,
                Importe: suma_impuesto_rete[el.clave]
              }
            });
          }
        });

        this.facturacion.Impuestos.TotalImpuestosTrasladados = total_total_impuesto_tras.toFixed(2);
        this.facturacion.Impuestos.TotalImpuestosRetenidos = total_total_impuesto_rete.toFixed(2);
      }

      let gran_total = total_subtotal - total_descuento + (total_total_impuesto_tras + total_total_impuesto_rete);

      this.facturacion.SubTotal = total_subtotal.toFixed(2);
      this.facturacion.Descuento = total_descuento.toFixed(2);
      this.facturacion.Total = gran_total.toFixed(2);

    }
  }

  timbrar() {
    document.getElementById("confirmarTimbrar").classList.remove("is-active");
    this.cargando = true;
    let json: any = this.facturacion;
    this.error_timbre = false;
    this.crudService.crear(json, this.CFDI_PATH + "/api/v1/facturar").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status === 201) {
          // datos de respuesta del pac
          let resupuesta = resultado.data;
          // obtener los datos de regreso de la api para la factura
          this.facturacion = resultado.json;

          // guardar la factura local para consultas posteriores
          this.guardar_factura(resultado);

          setTimeout(() => {
            document.getElementById("imprimir_pdf").click();
          }, 250);
        } else {
          if (resultado.messages.errores) {
            this.errores = resultado.messages.errores;
            setTimeout(() => {
              this.errores = [];
            }, 3500 * this.errores.length);
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = "";
            }, 3000);
          }
        }
      },
      error => {
        this.cargando = false;
        this.error_timbre = true;
        setTimeout(() => {
          this.error_timbre = false;
        }, 3500);
      }
    );
  }

  guardar_factura(respuesta) {
    let esto = this;
    respuesta["ventas"] = this.ventas_facturar;
    this.crudService
      .crear(respuesta, "factura")
      .subscribe(resultado => {
        esto.poner_factura_pp(resultado);
        this.ventas_facturar = [];
      }, error => {});
  }

  poner_factura_pp(resultado) {

    this.crudService.editar(this.idGuardado, resultado.data, 'pago-publico')
      .subscribe(data => {
      }, error => { });
  }

  quita_poner_iva(item) {
    item.iva = !item.iva;

    if (item.iva) {
      let suma_impuesto_rete = [];
      let suma_impuesto_tras = [];

      let impuesto_incluido = {
        Traslados: [],
        Retenciones: []
      };

      let impuestos = this.configuracion.sucursal.impuestos;
      let desglosar = 0;
      let imp_des = 0;

      impuestos.traslados.forEach(el => {
        let impp =
          item.precio_unitario -
          item.precio_unitario / (1 + parseFloat(el.cuota));
        desglosar += parseFloat(impp.toFixed(2));
        imp_des += parseFloat(el.cuota);
      });

      impuestos.retenciones.forEach(el => {
        let impp =
          item.precio_unitario -
          item.precio_unitario / (1 + parseFloat(el.cuota));
        desglosar += parseFloat(impp.toFixed(2));
        imp_des += parseFloat(el.cuota);
      });

      impuestos.traslados.forEach(el => {
        if (!suma_impuesto_tras[el.clave]) {
          suma_impuesto_tras[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_tras[el.clave] += parseFloat(impp.toFixed(2));
        impuesto_incluido.Traslados.push({
          Traslado: {
            Base: importe_impuesto,
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: impp.toFixed(2)
          }
        });
      });

      impuestos.retenciones.forEach(el => {
        if (!suma_impuesto_rete[el.clave]) {
          suma_impuesto_rete[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_rete[el.clave] += parseFloat(impp.toFixed(2));
        impuesto_incluido.Retenciones.push({
          Retencion: {
            Base: importe_impuesto,
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: impp.toFixed(2)
          }
        });
      });

      item.Impuestos = impuesto_incluido;
    } else {
      delete item.Impuestos;
    }
    this.recalcular_impuesto();
  }

  logo;
  logo_sucursal;
  logo_empresa;
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    }
  }
}
